// extracted by mini-css-extract-plugin
export var contact = "Footer-module--contact--a4b04";
export var contactList = "Footer-module--contact-list--1ae0a";
export var copyright = "Footer-module--copyright--d8645";
export var footer = "Footer-module--footer--519a5";
export var links = "Footer-module--links--37f40";
export var linksList = "Footer-module--links-list--7dc6f";
export var logoAndSocial = "Footer-module--logo-and-social--2f3b1";
export var navLinks = "Footer-module--nav-links--2531a";
export var socialLinks = "Footer-module--social-links--b70c4";